/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { pizzaConfiguration } from '../fn/pizza-configuration/pizza-configuration';
import { PizzaConfiguration$Params } from '../fn/pizza-configuration/pizza-configuration';
import { pizzaConfigurationGet } from '../fn/pizza-configuration/pizza-configuration-get';
import { PizzaConfigurationGet$Params } from '../fn/pizza-configuration/pizza-configuration-get';
import { PizzaConfigurationResult } from '../models/pizza-configuration-result';

@Injectable({ providedIn: 'root' })
export class PizzaConfigurationService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `pizzaConfigurationGet()` */
  static readonly PizzaConfigurationGetPath = '/pizza-configuration';

  /**
   * Get pizza configuration for tenant
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `pizzaConfigurationGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  pizzaConfigurationGet$Response(params: PizzaConfigurationGet$Params, context?: HttpContext): Observable<StrictHttpResponse<PizzaConfigurationResult>> {
    return pizzaConfigurationGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get pizza configuration for tenant
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `pizzaConfigurationGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  pizzaConfigurationGet(params: PizzaConfigurationGet$Params, context?: HttpContext): Observable<PizzaConfigurationResult> {
    return this.pizzaConfigurationGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<PizzaConfigurationResult>): PizzaConfigurationResult => r.body)
    );
  }

  /** Path part for operation `pizzaConfiguration()` */
  static readonly PizzaConfigurationPath = '/pizza-configuration';

  /**
   * Upsert pizza configuration for tenant
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `pizzaConfiguration()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  pizzaConfiguration$Response(params: PizzaConfiguration$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return pizzaConfiguration(this.http, this.rootUrl, params, context);
  }

  /**
   * Upsert pizza configuration for tenant
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `pizzaConfiguration$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  pizzaConfiguration(params: PizzaConfiguration$Params, context?: HttpContext): Observable<void> {
    return this.pizzaConfiguration$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
